/**
 * action types
 */
export const UPDATE_CERTIFICATION_PATHWAYS = 'UPDATE_CERTIFICATION_PATHWAYS';
export const CERTIFICATION_ASSESSMENT_REQUESTED_START =
  'CERTIFICATION_ASSESSMENT_REQUESTED_START';
export const CERTIFICATION_ASSESSMENT_REQUESTED_SUCCESS =
  'CERTIFICATION_ASSESSMENT_REQUESTED_SUCCESS';
export const CERTIFICATION_ASSESSMENT_REQUESTED_FAILURE =
  'CERTIFICATION_ASSESSMENT_REQUESTED_FAILURE';
export const CERTIFICATION_STUDENT_REGISTERED_SUCCESS =
  'CERTIFICATION_STUDENT_REGISTERED_SUCCESS';
export const CERTIFICATION_ISSUED_SUCCESS = 'CERTIFICATION_ISSUED_SUCCESS';
export const CERTIFICATION_REFRESHED_SUCCESS =
  'CERTIFICATION_REFRESHED_SUCCESS';
export const CERTIFICATION_PROMPT_RETRY_SUCCESS =
  'CERTIFICATION_PROMPT_RETRY_SUCCESS';
export const CERTIFICATION_UNDO_PROMPT_RETRY_SUCCESS =
  'CERTIFICATION_UNDO_PROMPT_RETRY_SUCCESS';
